import React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import Container from "@material-ui/core/Container";
import { Link } from "react-router-dom";
import Fade from "@material-ui/core/Fade";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";
import { connect } from "react-redux";
import { getDealers } from "../selectors";
import Typography from "@material-ui/core/Typography";
import { makeImgPropsList } from "./makeImgProps";
import SearchForm from "./SearchForm";
import { LazyLoadImage } from "react-lazy-load-image-component";

const useStyles = makeStyles((theme) =>
	createStyles({
		root: {
			display: "flex",
			flexWrap: "wrap",
			justifyContent: "space-around",
			overflow: "hidden",
			backgroundColor: theme.palette.background.paper,
		},
		noResults: {
			marginTop: theme.spacing(10),
			marginBottom: theme.spacing(20),
		},
		noImage: {
			textDecoration: "none",
			color: "black",
			fontSize: "32px",
		},
		gridList: {
			width: "100%",
			maxWidth: "100vw",
			height: "100%",
		},
		image: {
			objectFit: "contain",
			objectPosition: "top",
			width: "100%",
			height: "100%",
		},
		icon: {
			color: "rgba(255, 255, 255, 0.54)",
		},
	})
);

function getNoResultsText({ textSearch, selectedTags }) {
	let result = "No results";
	if (textSearch) {
		result += ` for ${textSearch}`;
	}
	if (selectedTags.length > 0) {
		result += ` matching tags ${selectedTags.join(",")}`;
	}
	return result;
}

export default connect((state) => ({
	dealers: getDealers(state),
	form: state.form,
}))(
	withWidth()(function TitlebarGridList(props) {
		const { dealers, form } = props;
		const classes = useStyles();

		const getGridListCols = () => {
			if (isWidthUp("lg", props.width)) {
				return 3;
			}

			if (isWidthUp("sm", props.width)) {
				return 2;
			}

			return 1;
		};
		return (
			<Fade in>
				<Container maxWidth="lg">
					<SearchForm inline />
					{dealers.length === 0 ? (
						<div className={classes.noResults}>
							<Typography variant="h3" gutterBottom>
								No dealers found :'(
							</Typography>
							<Typography variant="subtitle1" gutterBottom>
								{getNoResultsText(form)}
							</Typography>

							<Typography variant="subtitle2" gutterBottom>
								Try widening your search criteria
							</Typography>
						</div>
					) : (
						<div className={classes.root}>
							<GridList
								cols={getGridListCols()}
								className={classes.gridList}
								cellHeight={301}
							>
								{dealers.map((tile) => (
									<GridListTile
										to={`${process.env.REACT_APP_ROOT_URL}/dealer/${tile.id}`}
										component={Link}
										key={tile.id}
										style={{
											textDecoration: "none",
										}}
									>
										{tile.coverFile || tile.iconFile ? (
											<LazyLoadImage
												alt={tile.title}
												{...makeImgPropsList(
													tile.bannerFile ||
														tile.iconFile
												)}
												height={301}
												width="100%"
												effect="opacity"
												className={classes.image}
											/>
										) : (
											<h2 className={classes.noImage}>
												{tile.title}
											</h2>
										)}
										<GridListTileBar
											title={tile.title}
											subtitle={
												<span>
													{tile.headline !==
													tile.title
														? tile.headline
														: " "}
												</span>
											}
										/>
									</GridListTile>
								))}
							</GridList>
						</div>
					)}
				</Container>
			</Fade>
		);
	})
);
